module.exports = __webpack_public_path__ + "static/media/agenda.c6fa3052.png";